import React, { useEffect, useRef, useState } from 'react';
import styles from '../styles/reviews.module.css';
import {FadeIn} from "../../../shared/ui/animations";

const Review = ({ data, isFull = false, onRead, isBlurred = false, setActiveReviewId }) => {
    const { img, name, review } = data;
    const cardRef = useRef(null);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const el = cardRef.current;
        if (!el || !isMobile) return; // ❗ не анимируем на десктопе

        if (isFull) {
            const scrollHeight = el.scrollHeight;
            el.style.height = scrollHeight + 'px';

            const onTransitionEnd = (e) => {
                if (e.propertyName === 'height') {
                    el.style.height = 'auto';
                    el.removeEventListener('transitionend', onTransitionEnd);
                }
            };
            el.addEventListener('transitionend', onTransitionEnd);
        } else {
            el.style.height = el.scrollHeight + 'px';
            requestAnimationFrame(() => {
                el.style.height = '184px';
            });
        }
    }, [isFull, isMobile]);

    return (
        <FadeIn>
            <div
                ref={cardRef}
                className={`${styles.reviewCard} ${isFull ? styles.full : ''} ${isBlurred ? styles.blurred : ''}`}
            >
                <img src={img} alt={name} className={styles.cardDesc} />

                <div className={styles.reviewContent}>
                    <div className={styles.headerMobile}>
                        <img src={img} alt={name} />
                        <h4>{name}</h4>
                    </div>
                    <h4 className={styles.cardDesc}>{name}</h4>
                    <p className="body">{review}</p>

                    {!isFull ? (
                        <p className="btn-word w-auto" onClick={onRead}>[ Читать ]</p>
                    ) : (
                        <p className="btn-word w-auto" onClick={() => setActiveReviewId?.(null)}>[ Скрыть ]</p>
                    )}
                </div>
            </div>
        </FadeIn>
    );
};

export default Review;
